import type { Condition } from 'types/helios/templateForms';
import type { HeliosNotificationConditionsState, ConditionType } from '..';

export const updateCondition = (
  state: HeliosNotificationConditionsState,
  {
    payload,
  }: {
    payload: {
      type: ConditionType;
      index: number;
      condition: Condition;
    };
  }
) => {
  if (state[payload.type]?.conditions) {
    state[payload.type]!.conditions![payload.index] = payload.condition;
  }
};
